const STATUS_KEY = "pro_popup_status";
const REMIND_DATE_KEY = "pro_popup_remind_date";

function getTodayString() {
    return new Date().toISOString().split("T")[0];
}

// ─── Main: Should we show the popup? ──────────────────────────
export function shouldShowPopup() {
    // 1. Check env toggle first — if disabled, never show
    const envEnabled = import.meta.env.VITE_SHOW_PRO_PLAN_POPUP === "true";
    if (!envEnabled) return false;

    // 2. If user previously closed or redirected — never show again
    const status = localStorage.getItem(STATUS_KEY);
    if (status === "dismissed" || status === "redirected") return false;

    // 3. If user clicked "Remind Me Later" — only show if today >= remind date
    const remindDate = localStorage.getItem(REMIND_DATE_KEY);
    if (remindDate) {
        const today = getTodayString();
        if (today < remindDate) return false; // not yet — hide for now
    }

    return true;
}

// ─── Actions ──────────────────────────────────────────────────
export function onPopupDismissed() {
    localStorage.removeItem(REMIND_DATE_KEY); // clean up remind date if any
    localStorage.setItem(STATUS_KEY, "dismissed");
}

export function onPopupRemindLater() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowString = tomorrow.toISOString().split("T")[0];

    localStorage.setItem(REMIND_DATE_KEY, tomorrowString);
}

export function onPopupRedirected() {
    localStorage.removeItem(REMIND_DATE_KEY);
    localStorage.setItem(STATUS_KEY, "redirected");
}

// ─── Badge ────────────────────────────────────────────────────
export function shouldShowBadge() {
    return import.meta.env.VITE_SHOW_PRO_PLAN_BADGE === "true";
}
